/**
 * Default fixture for appointment_statuses.
 * Single source of truth for Figma-matching defaults.
 *
 * Used by:
 * - Server seed during org provisioning
 * - Client-side "Reset to Default" action
 */

export type AppointmentStatusType = 'normal' | 'terminal';

export interface AppointmentStatusDefault {
  label: string;
  type: AppointmentStatusType;
  color_hex: string;
  sort_order: number;
}

export const DEFAULT_APPOINTMENT_STATUSES: AppointmentStatusDefault[] = [
  { label: 'Scheduled', type: 'normal', color_hex: '#3b82f6', sort_order: 10 },
  { label: 'Confirmed', type: 'normal', color_hex: '#22c55e', sort_order: 20 },
  { label: 'Checked In', type: 'normal', color_hex: '#f59e0b', sort_order: 30 },
  { label: 'In Progress', type: 'normal', color_hex: '#f97316', sort_order: 40 },
  { label: 'Completed', type: 'terminal', color_hex: '#16a34a', sort_order: 50 },
  { label: 'Cancelled', type: 'terminal', color_hex: '#ef4444', sort_order: 60 },
  { label: 'No Show', type: 'terminal', color_hex: '#ef4444', sort_order: 70 },
];
